import FooterLinksWidget from './FooterLinksWidget';

export default FooterLinksWidget;
